import React, { useContext, useCallback, useState, useEffect } from 'react';

import { Container } from './styles';
import ThemeContext from '../../../../context/theme';
import iconLampDark from '../../../../assets/icons/luminaria.svg';
import iconLampLight from '../../../../assets/icons/luminaria_light.svg';
import logoDevariaDark from '../../../../assets/logo/logo-devaria-02.svg'
import logoDevariaLight from '../../../../assets/logo/logo-devaria-01.svg'
import useGetWindowWidth from '../../../../utils/useGetWindowWidth';
import windowSize from '../../../../constants/WindowSize';
import { ReactComponent as IconMoon } from '../../../../assets/icons/Moon.svg';
import { ReactComponent as IconSun } from '../../../../assets/icons/Sun.svg';

import { CMSService } from '../../../../../app/services';

const Header = ({ hasPadding, showIconTheme }) => {
  const { themeSelect, setTheme } = useContext(ThemeContext);
  const width = useGetWindowWidth();
  const [imageLogoB2b, setImageLogoB2b] = useState('');

  const loadFromCMS = useCallback(async () => {
    try {
      const [imageLogoB2b] = await Promise.all([
        CMSService.getContentFromYear('logo-light', 'slug,title,metadata')
      ]);

      const logourl = imageLogoB2b?.metadata?.logo?.url;

      setImageLogoB2b(logourl);
    } catch (e) {
      console.error(e);
    }
  }, [imageLogoB2b, themeSelect])

  useEffect(() => {
    loadFromCMS()
  }, [themeSelect])

  return (
    <Container width={width} hasPadding={hasPadding}>
      {/* // className='row align-items-center justify-content-between'> */}
      {width < windowSize.LG &&
        <img alt="logo Devaria"
          src={logoDevariaDark}
          style={{ width: 120 }} />
      }

      {showIconTheme &&
        <div
          onClick={
            () => themeSelect.title === 'dark' ?
              setTheme('light') :
              setTheme('dark')}>
          {themeSelect.title === 'dark'
            ? <IconSun style={{ cursor: 'pointer' }} />
            : <IconMoon style={{ cursor: 'pointer' }} />
          }
        </div>
      }
    </Container >
  );
};

export default Header;
